import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=c2cd7912&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2cd7912')) {
      api.createRecord('c2cd7912', component.options)
    } else {
      api.reload('c2cd7912', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=c2cd7912&", function () {
      api.rerender('c2cd7912', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2B6wGS5YGi759/JS/pricehelp.vue"
export default component.exports